import { useMemo } from "react";
import { Clock } from "lucide-react";

const timeFmt = new Intl.DateTimeFormat("es-VE", { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "America/Caracas" });

const minutesLeft = (iso) => Math.round((new Date(iso).getTime() - Date.now()) / 60000);

// Modo Lista: sorteos agrupados por bloque horario (Caracas), orden cronológico ascendente
export const ChronoSorteoList = ({ sorteos, lotteryMap, selectedSorteoIds, onToggle }) => {
  const blocks = useMemo(() => {
    const map = new Map();
    [...sorteos]
      .sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at))
      .forEach((s) => {
        const label = timeFmt.format(new Date(s.scheduled_at));
        if (!map.has(label)) map.set(label, { label, iso: s.scheduled_at, items: [] });
        map.get(label).items.push(s);
      });
    return [...map.values()];
  }, [sorteos]);

  if (blocks.length === 0) {
    return <div className="text-[11px] text-muted-foreground py-3 text-center" data-testid="pos-chrono-empty">Sin sorteos disponibles para este turno.</div>;
  }

  return (
    <div className="flex flex-col gap-2" data-testid="pos-chrono-list">
      {blocks.map((b, i) => {
        const mins = minutesLeft(b.iso);
        const slug = b.label.replace(/[^0-9a-z]/gi, "");
        return (
          <section key={b.label} className="rounded-xl border-2 border-border overflow-hidden" data-testid={`pos-chrono-block-${slug}`} data-block-index={i}>
            <header className="flex items-center justify-between px-3 py-1.5 bg-secondary/40 border-b-2 border-border/70">
              <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest" data-testid={`pos-chrono-block-title-${slug}`}>
                <Clock size={12} className="text-primary" /> Horario {b.label}
              </div>
              <div className="text-[10px] font-semibold text-muted-foreground">
                {b.items.length} sorteo{b.items.length === 1 ? "" : "s"}{mins >= 0 ? ` · en ${mins} min` : ""}
              </div>
            </header>
            <div className="grid grid-cols-2 gap-1.5 p-2">
              {b.items.map((s) => {
                const l = lotteryMap[s.lottery_type_id];
                const active = selectedSorteoIds.includes(s.id);
                const color = l?.color || "#1FB6A6";
                return (
                  <button key={s.id} type="button" onClick={() => onToggle(s)} data-testid={`pos-chrono-sorteo-${s.id}`} data-active={active}
                    className={`rounded-md border-2 px-2 py-1.5 text-left text-xs transition-colors ${active ? "border-primary bg-primary/20 text-foreground" : "border-border hover:bg-secondary/60 text-muted-foreground"}`}
                    style={{ boxShadow: `inset 3px 0 0 ${color}` }}>
                    <div className="font-bold truncate">{l?.name || "Lotería"}</div>
                    <div className="text-[10px] font-semibold truncate">{s.label || "Sorteo"}</div>
                  </button>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
};
